import React from 'react';
import number from '~/app/shared/util/utilities/number';

interface Props {
    textGroups: { label: string; value: number }[];
}

export default function PartialInvoicingBalanceInfo({ textGroups }: Props) {
    return (
        <div className="flex justify-between bg-grey-100 mt-5 py-2 px-2 border-y border-grey-300">
            {textGroups.map(group => (
                <div className="flex flex-col flex-grow" key={group.label}>
                    <span className="text-grey-700 mb-2">{group.label}</span>
                    <span className="text-grey-700">{number.format(group.value)}</span>
                </div>
            ))}
        </div>
    );
}
